import React, { useState } from "react";
import styles from "./subHeader.module.scss";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import { commarize } from "../../utils/helpers";
import BackButton from "./backButton";
import { ReactComponent as ContentCopy } from "../../assets/images/content-copy.svg";
import CopyToClipboard from "react-copy-to-clipboard";

const SubHeader = () => {
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false); // State for showing copy confirmation
  const body = queryString.parse(window.location.search);
  const { orderDetails } = useSelector((state) => state.orderDetailsReducer);
  const orderfee = useSelector((state) => state.orderFeeReducer);
  const fee: number = orderfee?.data?.customerFee ?? 0;
  const merchantEmail =
    orderDetails?.data?.subsidiary?.email ??
    orderDetails?.data?.customer?.email;
  const currency = orderDetails?.data?.order?.currency;
  const newamount = orderDetails?.data?.newAmount;
  const isDiscounted = orderDetails?.data?.isDiscounted;

  const baseAmount = isDiscounted
    ? newamount
    : orderDetails?.data?.order?.amount;
  const amountToDisplay =
    baseAmount != null
      ? `${currency ?? "NGN"} ${commarize(
          (Number(baseAmount) + fee).toFixed(10)
        )}`
      : null;

  const amountToCopy =
    baseAmount != null ? commarize((Number(baseAmount) + fee).toFixed(10)) : "";

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset the copied state after 2 seconds
  };

  return (
    <div className={styles.subHeader}>
      {/* <BackButton /> */}

      {/* Details of transaction */}
      <div className={styles.otherPaymentSummary}>
        <div className={styles.PaymentAmountWrapper}>
          <p className={styles.CustomerEmail}>{merchantEmail || ""}</p>

          {/* Display discounted amount if applicable */}
          {isDiscounted && (
            <p
              className={styles.PaymentAmount}
              style={{
                textDecoration: "line-through",
                fontWeight: "normal",
                color: "black",
              }}
            >
              {currency ?? "NGN"}
              {commarize((Number(orderDetails?.data?.oldAmount) + fee).toFixed(10))}
            </p>
          )}

          {/* Display new amount with copy functionality */}

          <p className={styles.PaymentAmount}>
            {" "}
            {amountToDisplay}
            <CopyToClipboard
              text={String(amountToCopy)}
              onCopy={() => handleCopy()}
            >
              <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                {copied ? (
                  "Copied!"
                ) : (
                  <>
                    <ContentCopy style={{ height: "17px" }} />
                  </>
                )}
              </span>
            </CopyToClipboard>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
